import Vue from "vue";
import { AclInstaller, AclCreate, AclRule } from "vue-acl";
import router from "@/router";

Vue.use(AclInstaller);

let initialRole = "editor";

let userInfo = JSON.parse(localStorage.getItem("userInfo"));
if (userInfo && userInfo.userRole) initialRole = userInfo.userRole;

export default new AclCreate({
	initial: initialRole,
	notfound: "/pages/login",
	router,
	acceptLocalRules: true,
	globalRules: {
		isAdmin: new AclRule("admin").generate(),
		isEditor: new AclRule("editor").or("admin").generate(),
		isSpecial: new AclRule("special").or("admin").generate()
		// public: new AclRule("public").or("admin").or("editor").generate(),
	}
});
